import { useContext } from 'react';
import Details from '@/common/TradeCard/Details';
import TradeContext from '~/context/common/TradeContext';
import useGetTradeInStatus from '~/hooks/common/useGetTradeStatus';
import { nativeStcPayload } from '~/native/common/utils';

type OwnProps = {
  ctaText: string;
};

export default function TradeDetails({ ctaText }: OwnProps) {
  const tradeStatus = useGetTradeInStatus();
  const { selectedTrade } = useContext(TradeContext);
  const { daysToExpiration = 0, id = '' } = selectedTrade ?? {};

  const ctaProps = {
    dataAnalyticsId: 'Home feed card',
    dataAnalyticsAttributes: JSON.stringify({
      description: 'STC card',
      expireDays: daysToExpiration,
      status: tradeStatus,
      cta: ctaText,
      item: 'view details'
    }),
    dataNativePayload: nativeStcPayload,
    dataQa: 'Trade view offer details link',
    href: `/sell-my-car/hub/${id}`
  };

  return <Details ctaProps={ctaProps} />;
}
